<template>
  <div class="modal-overlay">
    <div class="modal-card">

      <div class="icon-box success-bg border-round-lg flex align-items-center justify-content-center mb-4">
        <div class="border-circle flex align-items-center justify-content-center bg-green-500"
          style="width: 1.5rem; height: 1.5rem;">
          <i class="pi pi-check text-white" style="font-size: 0.8rem; font-weight: bold;"></i>
        </div>
      </div>

      <h2 class="text-xl font-bold mb-2 text-900" style="color: #14532D;">Account delete successful</h2>
      <p class="text-600 mb-5 text-sm">
        Your account is successfully deleted
      </p>

      <Button label="Go home" :class="buttonClass" @click="$emit('done')" />

    </div>
  </div>
</template>

<script setup>
import { computed, defineEmits, defineProps } from 'vue';
import Button from 'primevue/button';

const props = defineProps({
  role: { type: String }
});
defineEmits(['done']);

const buttonClass = computed(() => {
  switch (props.role) {
    case 'student': return 'orange-button';
    case 'tutor': return 'teal-button';
    case 'institute': return 'yellow-button';
    default: return 'orange-button';
  }
});
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(17, 24, 39, 0.295);
  padding: 1.5rem;
  backdrop-filter: blur(3px);
}

.modal-card {
  background: white;
  width: 100%;
  max-width: 45rem;
  padding: 4rem 3rem;
  border-radius: 0.5rem;
  box-shadow: 0 4px 20px -4px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.icon-box {
  width: 3.5rem;
  height: 3.5rem;
  border: 1px solid;
}

.success-bg {
  background: #F0FDF4;
  border-color: #BBF7D0;
}

@media (max-width: 640px) {
  .modal-overlay {
    padding: 1rem;
  }

  .modal-card {
    padding: 2rem 1.25rem;
  }
}
</style>
